import { render } from "./Form5.vue?vue&type=template&id=0b70f2dc&scoped=true"
import script from "./Form5.vue?vue&type=script&lang=js"
export * from "./Form5.vue?vue&type=script&lang=js"

import "./Form5.vue?vue&type=style&index=0&id=0b70f2dc&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b70f2dc"]])

export default __exports__